import React, {Component} from "react"
import {Panel, Col, Glyphicon, Checkbox} from "react-bootstrap"
import AscModal from "../Elements/Modal/Modal";
import InlineForm from "../Elements/FromGroup/InlineForm"
import "../Elements/FromGroup/form_select.css"
import * as GlobalConst from '../../components/AscConstants';

export default class OperatorUpdateModal extends Component {
    getUserInfoItem = () => {
        let {
            getScopeGreaterEqual,
            floor_flg,
            state,
            langText,
            charaLimit,
            onTextChange_Limit,
            onSelectChange,
            validationHandle,
            onCheckBoxChange,
            passwordValidationHandle
        } = this.props;
        let itemArr = [];

        itemArr.push(
            <InlineForm.static
                key = "companyId"
                controlId = "companyId"
                label = {langText.Body.CompanyName}>
                {state.companyName}
            </InlineForm.static>
        );

        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company))
        {
            itemArr.push(
                <InlineForm
                    key = "departmentId"
                    controlId = "departmentId"
                    label = {langText.Body.DepartmentName}
                    type = "select"
                    value = {state.departmentId}
                    onChange = {e => onSelectChange(e, "departmentId")}
                    options = {state.departmentSelect}
                    validationState = {validationHandle("departmentId")}
                    placeholder = {state.buttondisabledArr.departmentLoad[0] ? <Glyphicon glyph="refresh" className="spinning"/> : langText.SelectOption.Placeholder}
                    isDisabled = {!state.buttondisabledArr.departmentId[0]}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key = "departmentId"
                    controlId = "departmentId"
                    label = {langText.Body.DepartmentName}>
                    {state.departmentName}
                </InlineForm.static>
            );
        }

        if (floor_flg) {
            if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department))
            {
                itemArr.push(
                    <InlineForm
                        key = "floorId"
                        controlId = "floorId"
                        label = {langText.Body.FloorName}
                        type = "select"
                        value = {state.floorId}
                        onChange = {e => onSelectChange(e, "floorId")}
                        options = {state.floorSelect}
                        validationState = {validationHandle("floorId")}
                        placeholder = {state.buttondisabledArr.floorLoad[0] ? <Glyphicon glyph="refresh" className="spinning"/> : langText.SelectOption.Placeholder}
                        isDisabled = {!state.buttondisabledArr.floorId[0]}
                    />
                );
            } else if (state.modalType === "delete" || state.modalType === "read" || state.modalType === "insert"
                || state.modalType === "update")
            {
                itemArr.push(
                    <InlineForm.static
                        key = "floorId"
                        controlId = "floorId"
                        label = {langText.Body.FloorName}>
                        {state.floorName}
                    </InlineForm.static>
                );
            }
        }

        itemArr.push(
            <InlineForm.static
                key = "operatorId"
                controlId = "operatorId"
                label = {langText.Body.OperatorId}>
                {state.operatorId}
            </InlineForm.static>
        );

        itemArr.push(
            <InlineForm
                key = "operatorName"
                controlId = "operatorName"
                label = {langText.Body.OperatorName}
                type = "text"
                value = {state.operatorName}
                onChange = {e => onTextChange_Limit(e, "operatorName", charaLimit.Operator_Name)}
                validationState = {validationHandle("operatorName")}
            />
        );

        if (getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            itemArr.push(
                <Checkbox
                    key = "password-reset-flag"
                    className = "password-reset-flag"
                    checked = {state.passwordResetFlag}
                    onChange = {e => onCheckBoxChange(e, "passwordResetFlag")}
                >
                    {langText.Body.ResetPassword}
                </Checkbox>
            )
            if(state.passwordResetFlag){
                itemArr.push(
                    <InlineForm
                        key = "newPassword"
                        controlId = "newPassword"
                        label = {langText.Body.PasswordNew}
                        type = "password"
                        value = {state.newPassword}
                        onChange = {e => onTextChange_Limit(e, "newPassword",charaLimit.User_newPassword)}
                        validationState = {passwordValidationHandle("newPassword", state)}
                        placeholder = {langText.Message.Password_Validation}
                        autoComplete="new-password"/>
                );

                itemArr.push(
                    <InlineForm
                        key = "newPasswordRe"
                        controlId = "newPasswordRe"
                        label = {langText.Body.PasswordNewRe}
                        type = "password"
                        value = {state.newPasswordRe}
                        onChange = {e => onTextChange_Limit(e, "newPasswordRe",charaLimit.User_newPasswordRe)}
                        validationState = {passwordValidationHandle("newPasswordRe", state)}
                        placeholder = {langText.Message.Password_Validation}
                        autoComplete="new-password"/>
                );
                if((state.newPassword !== state.newPasswordRe) && (state.newPassword.length > 0 && state.newPasswordRe.length > 0)){
                    itemArr.push(
                        <p key = "newPasswordMismatch" className="text-danger">
                            {langText.Body.PasswordMismatch}
                        </p>
                    );
                }
            }
        }

        return itemArr;
    }

    render() {
        return (
            <AscModal
                state = {this.props.state}
                propSetState = {this.props.propSetState}
                langText = {this.props.langText}
                validationHandle = {this.props.validationHandle}
                onClick = {this.props.onClick}>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.UserInsert}
                        </Panel.Title>
                    </Panel.Heading>

                    <Panel.Body>
                        {this.getUserInfoItem()}
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}
